function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoinPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.298,3.823l2.863,-3.531l2.803,3.605l-1.056,10.449l-3.556,0l-1.056,-10.523Z",
    style: {
      fill: "#f1c41f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.503,7.635l2.237,-1.59l1.047,2.55l-2.305,5.907l-2.068,-0.575l1.089,-6.292Z",
    style: {
      fill: "#f7d55a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.213,9.656l0.198,-2.737l2.633,0.817l3.087,5.539l-1.761,1.228l-4.157,-4.846Z",
    style: {
      fill: "#f7d55a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.77,9.953l4.638,-1.129l-0.414,4.755l-4.638,1.129l0.414,-4.755Z",
    style: {
      fill: "#ffe37d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoinPanel);
export default __webpack_public_path__ + "static/media/iconCoinPanel.e8d0c65eb93442b4132ff11725dffde8.svg";
export { ForwardRef as ReactComponent };